export interface HrProps {
  className?: string
  thin?: boolean
}
